<template>
    <div>
        <div v-if="loading">
            <loading></loading>
        </div>

        <div v-else>
            <b-alert variant="danger" :show="hasErrors">
                <span v-html="errorMessage"></span>
            </b-alert>
            <div>
                <dead-line-filter />

                <vue-chart-bar
                    v-if="!loading"
                    :chartdata="chartData"
                    :options="chartOptions"
                ></vue-chart-bar>
            </div>
        </div>
    </div>
</template>

<script>
import vueChartBar from '../../../common/components/vueChartBar'
import loading from '../../../common/components/loading'
import DeadLineFilter from '../../../activity_management/activity/components/DeadLineFilter'
import TableHandler from '../../../common/mixins/TableHandler'
import DashboardHandler from '../../mixins/DashboardHandler'

export default {
    name: 'ChargeChart',

    components: {
        DeadLineFilter,
        vueChartBar,
        loading,
    },

    mixins: [TableHandler, DashboardHandler],

    data() {
        return {
            chartOptions: {
                responsive: true,
                maintainAspectRatio: false,

                animation: {
                    duration: 500,
                },
                hover: {
                    animationDuration: 0,
                },
                responsiveAnimationDuration: 0,

                legend: {
                    position: 'top',
                },
                scales: {
                    yAxes: [
                        {
                            ticks: {
                                beginAtZero: true,
                                stepSize: 5,
                            },
                        },
                    ],
                },
            },

            chartData: {
                labels: [
                    'jan',
                    'fév',
                    'mar',
                    'avr',
                    'mai',
                    'jun',
                    'jul',
                    'aou',
                    'sep',
                    'oct',
                    'nov',
                    'déc',
                ],
                datasets: [],
            },
        }
    },

    created() {
        this.$store.commit('browsing/SET_PAGE_NAME', 'chargeGraph')
    },

    async mounted() {
        await this.getChartData()
    },

    methods: {
        async getChartData() {
            try {
                this.loading = true
                const response = await axios.get(
                    `/reporting/charge/month/${this.year}/${this.deadlineFilter}`
                )
                this.setConfig(response.data)
                this.loading = false
            } catch (error) {
                // handle error
                console.log(error)
                // this.handleErrors(error.response)
            }
        },

        setConfig(responseData) {
            switch (this.chargeFilter) {
                case 'late':
                    this.setLateConfig(responseData)
                    break
                case 'soon':
                    this.setSoonConfig(responseData)
                    break
                case 'done':
                    this.setDoneConfig(responseData)
                    break
                default:
                    this.setAllConfig(responseData)
                    break
            }
        },

        setLateConfig(responseData) {
            this.chartData.datasets = [
                {
                    label: 'Retard par mois (en heures)',
                    backgroundColor: 'rgba(190, 55, 19, 0.4)',
                    borderColor: 'rgba(190, 55, 19, 1)',
                    borderWidth: 1,
                    height: 200,
                    data: responseData,
                },
            ]
        },

        setSoonConfig(responseData) {
            this.chartData.datasets = [
                {
                    label: 'A venir par mois (en heures)',
                    backgroundColor: 'rgba(229, 161, 23, 0.4)',
                    borderColor: 'rgba(229, 161, 23, 1)',
                    borderWidth: 1,
                    data: responseData,
                },
            ]
        },

        setDoneConfig(responseData) {
            this.chartData.datasets = [
                {
                    label: 'Réalisé par mois (en heures)',
                    backgroundColor: 'rgba(152, 190, 19, 0.4)',
                    borderColor: 'rgba(152, 190, 19, 1)',
                    borderWidth: 1,
                    data: responseData,
                },
            ]
        },

        setAllConfig(responseData) {
            this.chartData.datasets = [
                {
                    label: 'Planifié par mois (en heures)',
                    backgroundColor: 'rgba(77, 68, 61, 0.4)',
                    borderColor: 'rgba(77, 68, 61, 1)',
                    borderWidth: 1,
                    data: responseData,
                },
            ]
        },

        initChargeFilter() {
            this.chargeFilter = localStorage.chargeFilter
                ? localStorage.chargeFilter
                : 'all'
        },

        updateChargeFilter(value) {
            this.chargeFilter = value
            localStorage.chargeFilter = value
            this.getChartData()
        },
    },
}
</script>

<style scoped></style>
